import axiosPrivate from "../../../api/axiosPrivate";
import {
  APPROVE_CLAIM,
  CATEGORY_ACTIVE_POLICY,
  CREATE_CLAIM,
  CREATE_CLAIM_SETTINGS,
  DECLINE_CLAIM,
  GET_ALL_CLAIM_SETTINGS,
  GET_CLAIMS,
  GET_CLAIM_COMMENTS,
  GET_CLAIM_PROCESS_SETTINGS,
  GET_FILTERED_CLAIMS,
  GET_SINGLE_CLAIM,
  GET_SINGLE_CLAIM_SETTINGS,
  POLICYHOLDER_INFO,
  UPDATE_CLAIM,
  UPDATE_CLAIM_SETTINGS,
} from "../../../api/constant";

const getPolicyHolder = async ({ office_id, policy_number }) => {
  const response = await axiosPrivate.get(
    `${POLICYHOLDER_INFO}?office_id=${office_id}&policy_number=${policy_number}`
  );
  return response.data;
};

const getCategoryPolicy = async ({ office_id, policy_cat_id }) => {
  const response = await axiosPrivate.get(
    `${CATEGORY_ACTIVE_POLICY}?office_id=${office_id}&policy_cat_id=${policy_cat_id}`
  );
  return response.data;
};

const createClaimSettings = async (data) => {
  const response = await axiosPrivate.post(CREATE_CLAIM_SETTINGS, data);
  return response.data;
};

const updateClaimSettings = async (data) => {
  const response = await axiosPrivate.post(UPDATE_CLAIM_SETTINGS, data);
  return response.data;
};

const getAllClaimSettings = async ({pageNum, search}) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_CLAIM_SETTINGS}?page=${pageNum}&search=${search}`
  );
  return response.data;
};

const getSingleSettings = async (id) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_CLAIM_SETTINGS}?setting_id=${id}`
  );
  return response.data;
};

const getClaimProcessSettings = async ({ policy_cover, policy_id }) => {
  const response = await axiosPrivate.get(
    `${GET_CLAIM_PROCESS_SETTINGS}?policy_cover=${policy_cover}&policy_id=${policy_id}`
  );
  return response.data;
};

const createClaim = async (data) => {
  const response = await axiosPrivate.post(`${CREATE_CLAIM}`, data);
  return response.data;
};
const getClaims = async ({ office_id, search }) => {
  const response = await axiosPrivate.get(
    `${GET_CLAIMS}?office_id=${office_id}&search=${search}`
  );
  return response.data;
};

const getSingleClaim = async (claim_id) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_CLAIM}?claim_id=${claim_id}`
  );
  return response.data;
};
const declineClaim = async (data) => {
  const response = await axiosPrivate.post(DECLINE_CLAIM, data);
  return response.data;
};
const approveClaim = async (data) => {
  const response = await axiosPrivate.post(APPROVE_CLAIM, data);
  return response.data;
};
const updateClaim = async (data) => {
  const response = await axiosPrivate.post(UPDATE_CLAIM, data);
  return response.data;
};
const getClaimComments = async ({ claim_uuid, claim_id }) => {
  const response = await axiosPrivate.get(
    `${GET_CLAIM_COMMENTS}?claim_uuid=${claim_uuid}&claim_id=${claim_id}`
  );
  return response.data;
};

const FilteredGeneralPolicyClaims = async ({ office_id, staff_id }) => {
  const response = await axiosPrivate.get(
    `${GET_FILTERED_CLAIMS}?office_id=${office_id}&staff_id=${staff_id}`
  );
  return response.data;
};

const claimService = {
  getPolicyHolder,
  getCategoryPolicy,
  createClaimSettings,
  getAllClaimSettings,
  getSingleSettings,
  updateClaimSettings,
  getClaimProcessSettings,
  createClaim,
  getClaims,
  getSingleClaim,
  declineClaim,
  approveClaim,
  updateClaim,
  getClaimComments,
  FilteredGeneralPolicyClaims,
};

export default claimService;
